export const featureIDs = [
    'acuity_integration',
    'amplitude_integration',
    'automations_disabled',
    'calendly_integration',
    'campaign_filtering',
    'campaigns_disabled',
    'contact_groups',
    'external_contact_lists',
    'flows',
    'hubspot_integration',
    'hybrid_message_routing',
    'integration_logs',
    'intelligent_inbox',
    'intelligent_inbox_last',
    'local_attributes',
    'notifications',
    'omni_analytics',
    'quick_blast_ai',
    'quick_blast_cost_optimization',
    'revel_integration',
    'sentiment_analysis_ai',
    'shift_to_text',
    'skip_short_url_generation',
    'simple_message_hub',
    'single_sign_on',
    'subscriptions',
    'ten_dlc_send_rate_pacing',
    'time_zone_aware_campaigns',
    'transactional_default',
    'workflow_builder',
] as const;

export type FeatureID = (typeof featureIDs)[number];
export type Features = Record<FeatureID, boolean>;
